import { createAsyncThunk } from '@reduxjs/toolkit'
import { AdjustmentType } from '@dataTypes/adjustmentType.type'
import {
  getAllAdjustmentTypes,
  addAdjustmentType,
  updateAdjustmentType,
  deleteAdjustmentType,
  AdjustmentTypeListResponse,
  AdjustmentTypeQueryFilters,
  CreateAdjustmentTypeRequest,
  UpdateAdjustmentTypeRequest,
} from '@services/api/billing/adjustment-type.api'
import { RootState } from '@store/index'

export const getAllAdjustmentTypeSettings = createAsyncThunk<
  AdjustmentTypeListResponse,
  AdjustmentTypeQueryFilters | void,
  { rejectValue: string; state: RootState }
>(
  'api/adjustment-types/get/all',
  async (queryFilters, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const clinicId =
        state.clinic.selectedClinic?.clinic_id ||
        localStorage.getItem('clinic_id')

      const filters: AdjustmentTypeQueryFilters = {
        ...(queryFilters || {}),
      }
      if (clinicId) {
        filters.clinic_id = clinicId
      }

      const response = await getAllAdjustmentTypes(
        Object.keys(filters).length > 0 ? filters : undefined,
      )
      return response
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Failed to fetch adjustment type settings'
      return rejectWithValue(errorMessage)
    }
  },
)

export const addAdjustmentTypeSetting = createAsyncThunk<
  AdjustmentType,
  CreateAdjustmentTypeRequest,
  { rejectValue: string }
>(
  'api/adjustment-types/add/setting',
  async (newSetting, { rejectWithValue }) => {
    try {
      const adjustmentType = await addAdjustmentType(newSetting)
      return adjustmentType
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Failed to add adjustment type setting'
      return rejectWithValue(errorMessage)
    }
  },
)

export const updateAdjustmentTypeSetting = createAsyncThunk<
  AdjustmentType,
  UpdateAdjustmentTypeRequest,
  { rejectValue: string }
>(
  'api/adjustment-types/update/setting',
  async (payload, { rejectWithValue }) => {
    try {
      const adjustmentType = await updateAdjustmentType(payload)
      return adjustmentType
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Failed to update adjustment type setting'
      return rejectWithValue(errorMessage)
    }
  },
)

export const removeAdjustmentTypeSetting = createAsyncThunk<
  string,
  string,
  { rejectValue: string }
>('api/adjustment-types/remove/setting', async (id, { rejectWithValue }) => {
  try {
    await deleteAdjustmentType(id)
    return id
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to delete adjustment type setting'
    return rejectWithValue(errorMessage)
  }
})
